import { Component, OnInit, OnDestroy,Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HomepageService } from '../../../modules/dashboard/homepage/homepage.service';
import { ToastrService } from 'ngx-toastr';
import { UntypedFormBuilder, UntypedFormGroup, Validators, FormArray } from '@angular/forms';

@Component({
    selector: 'app-slugpages_view',
    templateUrl: './slugpages_view.component.html',
})

export class slugviewComponent implements OnInit, OnDestroy {
    SlugViewForm: UntypedFormGroup;
    submitted = false;
    loading = false;
    errors: string;
    slug_title:any;
    slug_description:any;

    constructor(
        private toastr: ToastrService,
        private homepageService: HomepageService,
        private route: ActivatedRoute,
        private router: Router,
        private formBuilder: UntypedFormBuilder) { }

    @Input() slug: string;

    ngOnInit() {
        // this.slug = this.route.snapshot.paramMap.get('id')
        this.homepageService.getactivepagefromslug(this.slug).subscribe(data=>{
            this.slug_title = data['pages'][0]['title']
            this.slug_description = data['pages'][0]['description']
        },error=>{this.toastr.error(JSON.stringify(error))})
    }

    onBack(){
        window.location.reload();
    }

    addTargetBlank() {
        if(this.slug_description){
            const a_tag = /<a (.*)>/g;
            return this.slug_description.replace(a_tag, '<a target="_blank" $1>');
        }    
    }

    ngOnDestroy(): void {
    }

}
